module.exports = ['$compile', '$rootScope', function ($compile, $rootScope) {

    $rootScope.directives = [];
    this.register = function (directive) {
        $rootScope.directives.push(directive);
        $rootScope.directives.sort(function (d1, d2) {
            return (d1.order || 0) - (d2.order || 0);
        });
        // this.apply();
    };

    // this.getDirectives = function () {
    //     return $rootScope.directives;
    // };

    // this.apply = function () {
    //     $('.navbar-right').html('');
    //     this.getDirectives().forEach(function (item) {
    //
    //         if (item.scope) {
    //             item.scope.$destroy();
    //         }
    //
    //         item.scope = angular.element('window').scope().$new();
    //
    //         angular.extend(item.scope, item.data);
    //
    //         $compile(item.html)(item.scope).appendTo('.navbar-right');
    //     })
    // }

}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/services/NavBarInjector.js
// module id = 317
// module chunks = 0